import { Result, Button } from 'antd'
import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Link to="/">
            <Button type="primary" size="large">
              Back to Dashboard
            </Button>
          </Link>
        }
      />
    </div>
  )
}

